import { bscCompensationContract } from 'bzx-common/src/config/appConfig'
import { airdrops } from 'bzx-common/src/services/AirdropService'
import React from 'react'
import ExternalLink from 'shared-components/ExternalLink'

const bscAirdrop = airdrops.BZRX_LOCKED

export function BZRXCompensationBSCInfo() {
  return (
    <div className="panel--simple md-padded-2">
      <h3 className="panel__header title-section">How does it work?</h3>
      <div className="txt-read-optimized">
        <div className="txt-explanation">
          <p className="txt-warning">
            <b>If you still have BZRX on BSC,</b> <br /> you will receive the compensation (BZRX) on
            Polygon.
          </p>
          <ol>
            <li className="margin-bottom-1">
              On BSC, you must send the BZRX you own to our Compensation contract.
            </li>
            <li>
              <p>
                After sending your BZRX on BSC, you will have to wait for an airdrop to be created
                on Polygon. You will receive the same amount that you sent to our contract on BSC.
              </p>
            </li>
          </ol>
        </div>
        <div className="panel--alternative padded-1 margin-top-2">
          <div className="margin-bottom-1">
            <h4 className="h4--muted margin-bottom-05">BSC Compensation Contract</h4>
            <ExternalLink
              className="link--discreet truncate--inline max-width-100p"
              href={`https://www.bscscan.com/address/${bscCompensationContract}`}>
              {bscCompensationContract}
            </ExternalLink>
          </div>
          <div>
            <h4 className="h4--muted margin-bottom-05">Polygon Airdrop Contract</h4>
            <ExternalLink
              className="link--discreet truncate--inline max-width-100p"
              href={`https://www.bscscan.com/address/${bscAirdrop.contract}`}>
              {bscAirdrop.contract}
            </ExternalLink>
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(BZRXCompensationBSCInfo)
